import React, { useEffect } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Contact.css';

const Contact = () => {
  const [state, handleSubmit] = useForm("mjvnljvj");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if we have a query parameter for the contact section
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('section') === 'contact') {
      // Scroll to the contact section
      const contactSection = document.getElementById('contact-section');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  if (state.succeeded) {
    return (
      <div className="contact-container">
        <div className="contact-content">
          <h2>Thank You!</h2>
          <p>Your message is received! Please allow us 2 business days to respond.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-container" id="contact-section">
      <div className="contact-left-column">
        <h2>Get in Touch</h2>
        <p>We'd love to hear from you! Whether you have a question about our services, pricing, or anything else, our team is ready to answer all your questions.</p>
        <div className="contact-info">
          <div className="info-item">
            <h3>Location</h3>
            <p>5 Charlesbank Road</p>
            <p>Newton, MA 02458</p>
          </div>
          <div className="info-item">
            <h3>Email</h3>
            <p>info@bylobyte.com</p>
          </div>
          <div className="info-item">
            <h3>Phone</h3>
            <p>+1 (551) 373-2595</p>
          </div>
        </div>
      </div>
      
      <div className="contact-right-column">
        <div className="contact-content">
          <h2>Contact Us</h2>
          <p>Have a question or want to work together? Send us a message!</p>
          
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                id="email"
                type="email" 
                name="email"
                className="form-control" 
                required
              />
              <ValidationError 
                prefix="Email" 
                field="email"
                errors={state.errors}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                className="form-control" 
                rows="7"
                required
              />
              <ValidationError 
                prefix="Message" 
                field="message"
                errors={state.errors}
              />
            </div>

            <button 
              className="submit-button" 
              type="submit" 
              disabled={state.submitting}
            >
              {state.submitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
